const {ccclass, property} = cc._decorator;

/**
 * 娱乐会所
 */
@ccclass
export default class FinancialCentrePrefab extends cc.Component {

    @property({type:cc.Prefab,displayName:"华尔街大佬"})
    wallStreetPrefab : cc.Prefab = null;
    @property({type:cc.Prefab,displayName:"基金购买"})
    stockPrefab : cc.Prefab = null;
}
